import { sanitize } from '@core/shared';
import { Heading, LoaderDots } from '@core/ui';
import { useTranslation } from 'react-i18next';

export const PreviewPanelOrganism = ({ isLoading, subject, html }: { isLoading?: boolean; subject?: string; html: string }) => {
    const config = { WHOLE_DOCUMENT: true, ADD_TAGS: ['link', 'meta', 'tbody'], ADD_ATTR: ['http-equiv', 'content'] };
    html = sanitize(html, config);
    const { t } = useTranslation();

    return (
        <div className="flex-1 w-full flex flex-col md:bg-[hsl(0_0%_100%/.75)] rounded-xl md:mx-4 md:px-12 xl:px-16 md:pt-8 xl:pt-12 md:pb-4 xl:pb-8">
            <Heading variant="h2" classNames="mt-3 mb-6">
                {t('Email.Preview.Heading')}
            </Heading>
            {isLoading && (
                <p>
                    {t('Email.Preview.Updating')}
                    <LoaderDots classNames="relative bottom-[-.17em] h-0.75em inline-block fill-current ms-1" />
                </p>
            )}
            {subject && (
                <p className="mb-4">
                    {t('Email.Template.Label.Subject')}: {subject}
                </p>
            )}
            <iframe style={{ width: '100%', height: '100%', minHeight: '800px', border: 'none' }} srcDoc={html}></iframe>
        </div>
    );
};
